import Footer from "../Footer/Footer"
import Navbar from "../Navbar/Navbar"
import DevsphireHeroSection from "./DevsphireHeroSection"
import DevsphireDev from "./DevsphireDev"

const Devsphire = () => {
  return (
    <div style={{
        height: "100%",
        margin: "0",
        padding: "0",
        // backgroundImage:
        //   "linear-gradient(90.1deg, rgba(8, 81, 98, 1) 14.5%, rgb(243, 198, 249) 135.4%)",
          backgroundColor:"#a3b18a",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}>
        <Navbar />
        <DevsphireHeroSection />
        <DevsphireDev />
        <Footer />
    </div>
  )
}

export default Devsphire